// extracted by mini-css-extract-plugin
export default {"flexColumn":"widgets-user-login-LoginWizard-steps-QuickLogin-fields-QuickLoginSetup__flexColumn--quo-h"};